import { Component } from '@angular/core';
import { SeoService } from '@geekeno/ngx-website/services';

@Component({
  selector: 'app-policies',
  imports: [],
  templateUrl: './policies.component.html',
  styleUrl: './policies.component.scss',
})
export class PoliciesComponent {
  constructor(seo: SeoService) {
    seo.setSEO({
      title: 'Applicable Policies at The Shore Agonda',
      description:
        "Discover the policies page of one of the best resorts in Agonda 'The Shore Agonda', outlining our commitment to ensuring a seamless and enjoyable experience for all guests. From reservation terms to cancellation policies, find all the information you need to plan your stay with confidence.",
    });
  }
}
